import React from 'react';
import styled from 'styled-components';
import { MobileNavigationStyle } from 'types/graphql';

type TabBarProps = {
  // The header intentionally ignores the configured color for every navigation
  // style, but callers still pass it since other app screens use it.
  // eslint-disable-next-line react/no-unused-prop-types
  backgroundColor?: string | null;
  logo?: string | null;
  navigationStyle?: MobileNavigationStyle | null;
};

const isSolidStyle = (navigationStyle?: MobileNavigationStyle | null): boolean =>
  navigationStyle === MobileNavigationStyle.solid;

const MobileHeader = ({ logo, navigationStyle }: TabBarProps): JSX.Element => {
  // Header background color is configured for other app screens, but the storefront header
  // itself remains transparent for every style. Elevation still distinguishes Solid.
  const showsElevation = isSolidStyle(navigationStyle);

  return (
    <MobileHeaderContainerV2 $showsElevation={showsElevation}>
      {!!logo?.length && (
        <LogoV2>
          <img src={logo} alt='Dispensary Name' />
        </LogoV2>
      )}
      <NameV2>Dispensary Name</NameV2>
    </MobileHeaderContainerV2>
  );
};

const MobileHeaderContainerV2 = styled.div<{ $showsElevation: boolean }>`
  background-color: transparent;
  box-shadow: ${({ $showsElevation }) => ($showsElevation ? '0 2px 8px rgba(0, 0, 0, 0.12)' : 'none')};
  // The header sits directly on the app canvas for every style, so its text
  // has to invert with that canvas. See ECOMM-12580.
  color: ${({ theme }) => (theme?.isBackgroundDark ? '#ffffff' : 'inherit')};
  padding: 40px 16px 10px;
  width: 100%;
`;

const NameV2 = styled.div`
  color: inherit;
  font-size: 24px;
  font-weight: bold;
`;

const LogoV2 = styled.div`
  img {
    max-height: 50px;
    width: auto;
  }
`;

export default MobileHeader;
